export var NOTIFICATION_BANNER_TESTID = 'NOTIFICATION_BANNER';
export var ONE_CLICK_TESTID = 'ONE_CLICK';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/constants/dataTestAttributes.js
// module id = 875
// module chunks = 11